/** @file A unique default name for a new entity (`skin`, `skin-2`, …) through format's slugifyName. */
import { slugifyName } from '@pose2d/format/slugifyName';

/** `base` when free, else `base-2`, `base-3`, …, at most 64 characters (CR-001); `base` must already be a valid name. */
export function freshName(base: string, taken: Iterable<string>): string {
  return slugifyName(base, new Set(taken), 1).name;
}
